<template>
  <div class="print">
    <!-- head -->
    <div class="print-head">
      <h1>안전보건 업무 전담조직</h1>
      <div class="stdInfo">
        <div>
          <span>사업장명</span>
          <span class="print-input"> {{ form.stdInfo.field_name }} </span>
        </div>
        <div>
          <span>작성자</span>
          <span class="print-input"> {{ form.stdInfo.writer_name }} </span>
        </div>
        <div>
          <span>작성일</span>
          <span class="print-input"> {{ form.stdInfo.date }} </span>
        </div>
      </div>
    </div>

    <div style="border: solid 1px black; width: 1430px; height: 140px; visibility: hidden"></div>

    <!-- body -->
    <div>
      <PrintNode ref="nodeContainer" v-for="c in setChart" :key="c.level" :value="c" notChild style="" />
    </div>
  </div>
</template>

<script>
import PrintNode from "./PrintNode.vue";

export default {
  name: "Print",
  components: { PrintNode },
  props: {
    form: Object,
    board: Object,
  },
  data() {
    return {
      chart: [],
    };
  },
  computed: {
    setChart() {
      return this.chart.filter((c) => c);
    },
  },
  created() {
    const t = this.form.organization;
    if (t.length < 1) return;
    t.map((item) => {
      if (!item.level) return;
      this.setData(item.level, item);
    });
  },
  mounted() {
    this.adjustDivSize();
  },
  methods: {
    // 입력값을 처리하는 함수
    setData(input, value) {
      // 입력값을 "-"로 분리하여 배열로 만듦
      let indices = input.split("-").map(Number);

      // 다차원 배열에 접근하여 값을 설정하는 재귀 함수
      function setNestedValue(arr, idxArr, value) {
        let index = idxArr[0] - 1;

        // 마지막 인덱스인 경우, 값을 설정
        if (idxArr.length === 1) {
          arr[index] = { ...value, child: [] };
        } else {
          // 하위 배열이 존재하지 않으면 생성
          if (!arr[index]) {
            arr[index].child = [];
          }
          // 재귀 호출
          setNestedValue(arr[index].child, idxArr.slice(1), value);
        }
      }
      // 초기 함수 호출
      setNestedValue(this.chart, indices, value);
    },
    adjustDivSize() {
      this.setChart.map((sc, sc_i) => {
        // Window의 가로크기 구하기
        var windowWidth = 1430;

        // Div의 가로크기 구하기 (예시: id가 "myDiv"인 경우)
        var divWidth = document.getElementById(`w-${sc.level}`).offsetWidth;

        // 비율 계산
        var ratio = windowWidth / divWidth;
        if (1 < ratio) ratio = 1;

        this.$refs.nodeContainer[sc_i].$el.style.transform = `scale(${ratio})`;
      });
    },
    countLeafNodes(data) {
      let leafCount = 0;

      for (let i = 0; i < data.length; i++) {
        let isLeaf = true;

        for (let j = i + 1; j < data.length; j++) {
          if (data[j].level.startsWith(data[i].level)) {
            isLeaf = false;
            break;
          }
        }

        if (isLeaf) {
          leafCount++;
        }
      }

      return leafCount;
    },
  },
};
</script>

<style lang="scss" scoped>
.print-head {
  padding-bottom: 1rem;
  border-bottom: 1px solid #cdcdcd;

  h1 {
    font-weight: bold;
    text-align: center;
    padding: 20px 0 14px;
  }
  .stdInfo {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 1rem;
    margin-top: 20px;
    div {
      display: grid;
      grid-template-columns: 114px 1fr;
      align-items: center;
      span {
        margin-right: 10px;
      }
    }
  }
}
</style>
